export default function PreviousIcon() {
    return (
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg--stroke">
            <path d="M12.8203 8.4999H4.82029M4.82029 8.4999L8.82029 12.4999M4.82029 8.4999L8.82029 4.4999M8.82031 16.5C4.40203 16.5 0.820312 12.9183 0.820312 8.5C0.820312 4.08172 4.40203 0.5 8.82031 0.5C13.2386 0.5 16.8203 4.08172 16.8203 8.5C16.8203 12.9183 13.2386 16.5 8.82031 16.5Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}